var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShiftIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.325 15.897a.625.625 0 0 0-.874.128 6.808 6.808 0 0 1-.36.445.625.625 0 0 0 .936.827c.149-.168.293-.345.427-.526a.625.625 0 0 0-.129-.874zM19.37 12.96a.625.625 0 0 0-.743.477c-.04.186-.089.372-.145.553a.625.625 0 0 0 1.194.369c.067-.215.125-.435.173-.656a.625.625 0 0 0-.478-.743zM15.318 17.9a6.79 6.79 0 0 1-.51.257.625.625 0 1 0 .514 1.14 8.03 8.03 0 0 0 .605-.306.625.625 0 1 0-.609-1.091zM11.374 7v4.741l-2.292 2.292a.625.625 0 0 0 .884.884l2.475-2.475a.625.625 0 0 0 .183-.442V7a.625.625 0 1 0-1.25 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.375 5.344a.625.625 0 0 0-.625.625v1.735A8.019 8.019 0 0 0 12 4a7.948 7.948 0 0 0-5.657 2.343A7.948 7.948 0 0 0 4 12c0 2.137.832 4.146 2.343 5.657A7.948 7.948 0 0 0 12 20h.031c.226 0 .453-.01.676-.028a.625.625 0 1 0-.104-1.246 6.89 6.89 0 0 1-.572.024H12A6.758 6.758 0 0 1 5.25 12 6.758 6.758 0 0 1 12 5.25a6.766 6.766 0 0 1 5.81 3.313h-1.718a.625.625 0 1 0 0 1.25H18a1.988 1.988 0 0 0 1.096-.329A2 2 0 0 0 20 7.813V5.968a.625.625 0 0 0-.625-.625z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShiftIcon);
export default __webpack_public_path__ + "static/media/shift-icon.e120a7c2.svg";
export { ForwardRef as ReactComponent };